<template>
  <section>
    <div class="mb-4">
      <div>
        <h3 class="text-base font-semibold">Start time</h3>
        <p class="text-mdx text-dark/70">Please arrive 15 minutes before</p>
      </div>
    </div>

    <div v-if="timeLoading" :class="feedbackPanelClasses">
      Loading times...
    </div>
    <div v-else-if="availableTimes.length === 0" :class="feedbackPanelClasses">
      No times available for this date.
    </div>
    <div
      v-else
      class="grid gap-2"
      :class="timeListClasses"
    >
      <button
        v-for="timeOption in displayedTimes"
        :key="timeOption.startTimeLocal"
        :class="timeButtonClasses(timeOption)"
        :disabled="timeOption.disabled"
        @click="$emit('select-time', timeOption)"
      >
        <span class="flex min-w-0 flex-wrap items-baseline justify-center gap-1">
          <span v-text="`${timeOption.hourMinutes}`" class="font-bold text-2xl"></span>
          <span v-text="`${timeOption.meridiem}`" class="text-lg uppercase"></span>
        </span>
        <span v-if="timeOption.seatsAvailable < 1" class="max-w-full break-words text-sm uppercase lg:text-base">
          {{ walkInOnlyDate ? 'Walk in only' : 'Sold Out' }}
        </span>
        <span
          v-else-if="false && timeOption.seatsAvailable > scarcityLimit"
          class="max-w-full break-words text-sm lg:text-base"
          v-text="`${timeOption.seatsAvailable} available`"
        ></span>
        <span
          v-else-if="timeOption.seatsAvailable <= scarcityLimit"
          class="max-w-full break-words text-sm lg:text-base"
          v-text="`Only ${timeOption.seatsAvailable} remaining`"
        ></span>
      </button>

      <button
        v-if="hasExtraTimes"
        type="button"
        :class="moreTimesButtonClasses"
        @click="$emit('toggle-more-times')"
      >
        <span class="flex h-12 w-12 items-center justify-center rounded-full bg-dark text-[30px] leading-none text-light">
          {{ showAllTimes ? '-' : '+' }}
        </span>
        <span class="text-center text-sm font-semibold leading-tight">
          {{ showAllTimes ? 'Fewer times' : 'More times' }}
        </span>
      </button>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  timeLoading: {
    type: Boolean,
    default: false,
  },
  availableTimes: {
    type: Array,
    default: () => [],
  },
  displayedTimes: {
    type: Array,
    default: () => [],
  },
  hasExtraTimes: {
    type: Boolean,
    default: false,
  },
  showAllTimes: {
    type: Boolean,
    default: false,
  },
  selectedTime: {
    type: String,
    default: '',
  },
  walkInOnlyDate: {
    type: Boolean,
    default: false,
  },
  fullscreenActive: {
    type: Boolean,
    default: false,
  },
  cartLayout: {
    type: Boolean,
    default: false,
  },
  scarcityLimit: {
    type: Number,
    default: 5,
  },
})

defineEmits(['select-time', 'toggle-more-times'])

const cardBackgroundClass = computed(() => (props.fullscreenActive ? 'bg-light' : 'bg-white'))
const feedbackPanelClasses = computed(() => `rounded-3xl ${cardBackgroundClass.value} px-6 py-12 text-center text-dark/70`)
const timeListClasses = computed(() => (
  props.fullscreenActive || props.cartLayout
    ? 'w-full min-w-0 max-w-full grid-cols-2 overflow-x-hidden sm:grid-cols-3 lg:grid-cols-[repeat(5,minmax(0,1fr))]'
    : 'grid-cols-[repeat(3,minmax(0,1fr))]'
))
const moreTimesButtonClasses = computed(() => (
  props.fullscreenActive
    ? 'flex min-h-[104px] flex-col items-center justify-center gap-3 rounded-2xl bg-transparent text-dark transition hover:bg-light'
    : 'flex min-h-[80px] flex-col items-center justify-center gap-2 rounded-lg bg-transparent text-dark transition hover:bg-white'
))

const timeButtonClasses = (timeOption) => {
  let base = 'flex h-full min-w-0 w-full flex-col items-center justify-center gap-1 overflow-hidden rounded-lg p-2 text-center'

  base = props.fullscreenActive  ? `${base} min-h-[104px]` : `${base} min-h-[80px]`


  if (timeOption.seatsAvailable > 0 && timeOption.startTimeLocal === props.selectedTime) {
    return `${base} bg-dark text-light`
  }

  if (timeOption.seatsAvailable > 0) {
    return `${base} ${cardBackgroundClass.value} text-dark hover:bg-dark hover:text-light`
  }

  return `${base} ${cardBackgroundClass.value} text-dark`
}
</script>
